<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Save', isDisabled : !customForm.valid || spin, spin: spin}
  ]"
  (action)="action($event)"
  (close)="close()"
>
<div class="dialog-container">
  <form [formGroup]="customForm">
  <div class="top_form">
    <div class="input-container">
      <label class="input-container_label">Date From</label>
      <mat-form-field appearance="fill" class="mat-select-control w-100" [ngClass]="{'error':  customForm.controls['dateFrom'].touched && customForm.controls['dateFrom'].errors }">
        <input matInput class="border-0" (click)="pickDate.open()" [matDatepicker]="pickDate" readonly formControlName="dateFrom" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="pickDate"></mat-datepicker-toggle>
        <mat-datepicker #pickDate> </mat-datepicker>
      </mat-form-field>
    </div>
    <div class="custom-mat-radio font-regular">
      <mat-radio-group aria-label="Select an option" formControlName="isPeriod" >
        <mat-radio-button [value]=true color="primary" >
          Cost Period
        </mat-radio-button>
      
        <mat-radio-button [value]=false color="primary" >
          Cost Qty
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="input-container" *ngIf="show">
      <label class="input-container_label">Date To</label>
      <mat-form-field appearance="fill" class="mat-select-control w-100" [ngClass]="{'error':  customForm.controls['dateTo'].touched && customForm.controls['dateTo'].errors }">
        <input matInput readonly (click)="pickDateTo.open()"[min]="customForm.get('dateFrom').value"[matDatepicker]="pickDateTo" formControlName="dateTo" readonly autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="pickDateTo"></mat-datepicker-toggle>
        <mat-datepicker #pickDateTo> </mat-datepicker>
      </mat-form-field>
    </div>
    <div class="input-container" *ngIf="!show">
      <label class="input-container_label">Qty</label>
      <div class="input-container_wrapper">
        <input type="number" class="input-container_input" formControlName="qty">
      </div>
    </div>
    <div class="input-container">
      <label class="input-container_label">Price</label>
      <div class="input-container_wrapper">
        <input type="number" class="input-container_input input-container_input--number" formControlName="price">
        <span class="input-container_icon">
          $
        </span>
      </div>
    </div>
  </div>
</form>
</div>
</app-dialog>
